import { cn } from '#/lib/utils';
import { ComponentProps, ReactNode } from 'react';
import { useFormField } from '../ui/form';

interface FormMessageProps extends ComponentProps<'p'> {
  errors?: Record<string, ReactNode>;
}
/**
 * FormMessage with errors record
 */
export function FormMessage({ className, errors, ...props }: FormMessageProps) {
  const { error, formMessageId } = useFormField();

  const messageOrKey = error?.message;

  const body =
    error != null
      ? messageOrKey != null
        ? errors?.[messageOrKey] ?? messageOrKey
        : null
      : props.children;

  if (!body) {
    return null;
  }

  return (
    <p
      data-slot="form-message"
      id={formMessageId}
      className={cn('text-destructive text-sm', className)}
      {...props}
    >
      {body}
    </p>
  );
}
